/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PublicDataRemovalRequestShowPathParams,
	PublicDataRemovalRequestShowResponse,
} from '../types/PublicDataRemovalRequestShow'

/**
 * GET /data-removal/:token
 * @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::show
 */
export async function publicDataRemovalRequestShow(
	token: PublicDataRemovalRequestShowPathParams['token'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicDataRemovalRequestShowResponse>> {
	return axiosInstance.get(`/data-removal/${token}`, config)
}
